import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Data20ir384tdyz1e as Data } from '../SaveBoostMutation.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data_0() {
  if (DataClass === VOID) {
    class $ {
      constructor() {
        Data_instance = this;
        this.g6m_1 = listOf('saveBoost');
      }
      g40(reader, customScalarAdapters) {
        var _saveBoost = null;
        $l$loop: while (true) {
          if (reader.e4f(this.g6m_1) === 0)
            _saveBoost = get_NullableBooleanAdapter().g40(reader, customScalarAdapters);
          else
            break $l$loop;
        }
        return new (Data())(_saveBoost);
      }
      h6m(writer, customScalarAdapters, value) {
        writer.c4d('saveBoost');
        get_NullableBooleanAdapter().l40(writer, customScalarAdapters, value.k6j_1);
      }
      h40(writer, customScalarAdapters, value) {
        return this.h6m(writer, customScalarAdapters, value instanceof Data() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Data', VOID, VOID, [Adapter()]);
    DataClass = $;
  }
  return DataClass;
}
var Data_instance;
function Data_getInstance() {
  if (Data_instance === VOID)
    new (Data_0())();
  return Data_instance;
}
//region block: exports
export {
  Data_getInstance as Data_getInstance1s3vilyqyn4db,
};
//endregion

//# sourceMappingURL=SaveBoostMutation_ResponseAdapter.mjs.map
